import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import {BrowserView, MobileView} from 'react-device-detect'
import React, {useContext, useEffect, useState} from 'react'
import {TransmissionsFilters} from './TransmissionsFilters.tsx';
import {TransmissionsTab} from './TransmissionsTab.tsx';
import Title from "../../ui/page/Title";
import Box from '../../ui/box/Box';
import {TabMenu} from '../../ui/menu/TabMenu';
import {
    ORDER_TYPE_TODAY,
    useStoreTransmissions,
} from '../../../store/useStoreTransmissions.ts'
import AuthContext from '../../../contexts/AuthContext';
import OrderCardGroup from '../../ui/card/OrderCardGroup';
import {useActionButtons} from '../../../hooks/transmissions/useActionButtons.ts';
import {ITEMS_PER_PAGE_DASHBOARD_TRANS} from '../../../constants/Constants';

export const TransmissionsNew = () => {
    const {user} = useContext(AuthContext);
    const type = useStoreTransmissions((state) => state.type)
    const setType = useStoreTransmissions((state) => state.setType)
    const isLoading = useStoreTransmissions((state) => state.isLoading)
    const transmissionCount = useStoreTransmissions(
        (state) => state.transmissionCount,
    );
    const fetchTransmissions = useStoreTransmissions(
        (state) => state.fetchTransmissions,
    );
    const transmissions = useStoreTransmissions((state) => state.transmissions);
    const isError = useStoreTransmissions((state) => state.isError);
    const sortOrder = useStoreTransmissions((state) => state.sortOrder);
    const sortType = useStoreTransmissions((state) => state.sortType)
    const {
        actionButtons,
        actionPendingButtons,
    } = useActionButtons();
    const [types] = useState([
        {type: 'enattente', title: 'En attente', pathname: 'transmissions'},
        {type: ORDER_TYPE_TODAY, title: `Aujourd'hui`, pathname: 'transmissions'},
        {type: 'yesterday', title: 'Hier', pathname: 'transmissions'},
        {
            type: 'last-week',
            title: 'Semaine dernière',
            pathname: 'transmissions',
        },
        {type: 'last-month', title: 'Mois dernier', pathname: 'transmissions'},
        {
            type: 'by-last-days',
            title: '30 derniers jours',
            pathname: 'transmissions',
        },
        {type: 'search', title: 'Recherche', pathname: 'transmissions'},
    ])

    useEffect(() => {
        if (type === 'dashboard') {
            setType(ORDER_TYPE_TODAY)
        }

        fetchTransmissions(true)
    }, [type, user, sortOrder, sortType])

    return (
        <Col xs={12}>
            <Title title={'Mes transmissions'} />
            <TransmissionsFilters />
            <Row>
                <Col xs={12}>
                    <Box
                        boxName={'transmissions'}
                        boxContentBg={'white'}
                        content={
                            <>
                                <BrowserView renderWithFragment={true}>
                                    <TabMenu
                                        setCurrentTabFunction={setType}
                                        currentTab={type}
                                        tabs={types}
                                        isLoading={isLoading}
                                        numberOfElements={transmissionCount}
                                    />
                                    <TransmissionsTab />
                                </BrowserView>
                                <MobileView renderWithFragment={true}>
                                    <TabMenu
                                        currentTab={type}
                                        tabs={types}
                                        numberTabsToShow={3}
                                        isLoading={isLoading}
                                        setCurrentTabFunction={setType}
                                    />
                                    <OrderCardGroup
                                        isLoading={isLoading}
                                        isError={isError}
                                        data={transmissions}
                                        actionButtons={
                                            type === 'enattente'
                                                ? actionPendingButtons
                                                : actionButtons
                                        }
                                        max={ITEMS_PER_PAGE_DASHBOARD_TRANS}
                                        user={user}
                                    />
                                </MobileView>
                            </>
                        }
                    />
                </Col>
            </Row>
        </Col>
    )
}
